import React, { useRef, useEffect } from 'react'

function Navbar(props) {
  const { data, className = '', callback, indexData } = props
  const navbar = useRef(null)

  useEffect(() => {
    setTimeout(() => {
      const items = navbar.current.querySelectorAll('li')
      items[0].classList.add('is-active')
      animateIndicator(items[0])
    }, 1000)
  }, [callback])

  const onClickItem = (event, index) => {
    const target = event.target
    const items = navbar.current.querySelectorAll('li')

    // Display active link
    for (let i = 0; i < items.length; i++) {
      const item = items[i]
      item.classList.remove('is-active')
    }
    target && target.classList.add('is-active')

    // Translate indicator animation
    animateIndicator(target)

    callback && callback(index)
  }

  const animateIndicator = (target) => {
    const indicator = navbar.current.querySelector('.navbar__indicator')
    indicator.style.left = target.offsetLeft + 'px'
    indicator.style.width = target.offsetWidth + 'px'
  }

  return (
    <ul ref={navbar} className={`navbar ${className}`}>
      {data.map(
        (currentData, i) =>
          currentData && (
            <li key={i}>
              <span
                data-name={currentData.block ? currentData.block.document.data.title.text : currentData}
                className={indexData === i ? 'is-active' : ''}
                role="button"
                tabIndex="0"
                onClick={(e) => onClickItem(e, i)}
                onKeyDown={(e) => onClickItem(e, i)}
              >
                {currentData.block ? currentData.block.document.data.title.text : currentData}
              </span>
            </li>
          )
      )}
      <span className="navbar__indicator"></span>
    </ul>
  )
}

export default Navbar
